import type { IMainLayoutTranslations } from '../types/mainLayout.types';

export const useMainLayoutTranslationsPTBR = () => {
  const ptBR: IMainLayoutTranslations = {
    menu: {
      profile: 'Perfil',
      accountSettings: 'Configurações da Conta',
      supportMode: 'Entrar no modo de Suporte',
      leaveSupportMode: 'Sair do Modo de Suporte',
    },
    main: {
      api: 'API',
      reports: 'Relatórios',
      devices: {
        title: 'Dispositivos',
        deviceList: 'Lista de Dispositivos',
      },
      healthCheck: 'Saúde dos Dispositivos',
      projections: {
        title: 'Projeções',
        dashboard: 'Visão do Dashboard',
      },
      groups: {
        title: 'Grupos',
        chooseGroup: 'Criar grupos',
      },
      deviceBlocks: 'Gestão de bloqueios',
      tagsManagement: 'Gestão de tags',
      settings: 'Configurações',
    },
    settings: {
      overview: 'Visão geral',
      myAccount: 'Minha conta',
      loginSecurity: 'Login e Segurança',
      users: 'Usuários',
      audit: 'Auditoria',
    },
    developer: {
      title: 'Desenvolvedor',
      sdk: 'SDK',
      batch: 'Batch',
      credentials: 'Credenciais',
    },
    globalErrorBoundary: {
      title: 'Oops! Algo deu errado',
      description: 'Ocorreu um erro inesperado. Nossa equipe foi notificada.',
      contactSupport: 'Falar com suporte',
      tryAgain: 'Tentar novamente',
    },
  };

  return ptBR;
};
